<template>
  <div class="nav">
    <!-- 主内容区 -->
    <div class="nav-c">
      <!-- 1. 导航链接区 -->
      <div class="nav-c1">
        <div class="c1-h">
          <li class="head">企业概况</li>
          <li><router-link to="/about?tab=culture">企业文化</router-link></li>
          <li><router-link to="/about?tab=course">发展历程</router-link></li>
          <li><router-link to="/about?tab=matrix">办公环境</router-link></li>
          <li><router-link to="/about?tab=honer">企业荣誉</router-link></li>
        </div>
        <div class="c1-h">
          <li class="head">解决方案</li>
          <li><router-link to="/industry/gonglu">公路运输</router-link></li>
          <li><router-link to="/industry/tielu">铁路运输</router-link></li>
          <li><router-link to="/industry/shuilu">水路运输</router-link></li>
          <li><router-link to="/industry/cangchu">仓储统配</router-link></li>
        </div>
        <div class="c1-h">
          <li class="head">新闻中心</li>
          <li><router-link to="/newsCenter?type=0">公司新闻</router-link></li>
          <li><router-link to="/newsCenter?type=1">行业资讯</router-link></li>
        </div>
        <div class="c1-h">
          <li class="head">人力资源</li>
          <li><router-link to="/join">招聘信息</router-link></li>
        </div>
      </div>

      <!-- 2. 公司联系信息区 -->
      <div class="nav-c2" v-if="$store.state.config['contact_info']">
        <img src="../assets/logo-b.png" class="c2-img" />
        <div class="c2-div">
          <span class="contact-item">
            全国服务热线：
            <a :href="'tel:' + $store.state.config['contact_info'].label1">
              {{ $store.state.config["contact_info"].label1 }}
            </a>
          </span>
          <span class="contact-item item-email">
            邮箱：
            <a :href="'mailto:' + $store.state.config['contact_info'].label2">
              {{ $store.state.config["contact_info"].label2 }}
            </a>
          </span>
        </div>
        <div class="c2-txt">
          总部地址：{{ $store.state.config["contact_info"].label3 }}
        </div>
      </div>

      <!-- 3. 二维码区 -->
      <div class="nav-c3" v-if="$store.state.config['contact_info']">
        <el-image
          style="width: 100px"
          :src="$store.state.config['contact_info'].img"
          class="c3-img"
          :preview-src-list="[$store.state.config['contact_info'].img]"
        >
        </el-image>
        <div class="c3-txt1">
          {{ $store.state.config["contact_info"].label4 }}
        </div>
      </div>
    </div>

    <!-- 分割线 -->
    <div class="line"></div>

    <!-- 4. 版权与备案区 -->
    <div class="nav-d">
      <span class="copy-txt">Copyright © 2006-2026</span>
      <span class="copy-txt company-name">湖南安迅物流运输有限公司</span>
      <span class="copy-txt beian">
        <img
          src="../assets/img/gongan.png"
          style="width: 14px; vertical-align: middle; margin-right: 4px"
        />
        <a href="http://beian.miit.gov.cn/" target="_blank"
          >湘ICP备20005592号</a
        >
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomNav",
  props: {
    msg: String,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
/* ==================== PC 端默认样式 ==================== */
.nav {
  width: 100%;
  background: #17213d;
  padding-top: 40px;
  padding-bottom: 20px;
}

.nav-c {
  width: 80%;
  max-width: 1200px;
  margin: 0 auto 30px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

/* 导航列 */
.nav-c1 {
  width: 45%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.c1-h {
  padding: 0;
  margin: 0;
}

.c1-h li {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  list-style-type: none;
  margin-bottom: 12px;
}

.c1-h .head {
  font-size: 16px;
  font-weight: 500;
  color: #dddddd;
  margin-bottom: 24px;
}

/* 联系信息 */
.nav-c2 {
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 40px; /* 适当缩小原 100px 的硬编码 */
}

.c2-img {
  width: 180px;
  height: auto;
}

.c2-div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 15px;
  color: #ffffff;
  margin-top: 10px;
}

.item-email {
  margin-left: 40px; /* 改用具体类控制，方便移动端覆盖 */
}

.c2-txt {
  font-size: 14px;
  color: #ffffff;
  margin-top: 15px;
  line-height: 1.6;
}

/* 二维码 */
.nav-c3 {
  width: 15%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.c3-img {
  width: 100px;
  height: 100px;
}

.c3-txt1 {
  font-size: 13px;
  color: #ffffff;
  margin-top: 12px;
  text-align: center;
}

/* 底部底线与版权 */
.line {
  width: 80%;
  max-width: 1200px;
  height: 1px;
  background: #2c395b;
  margin: 0 auto;
}

.nav-d {
  width: 80%;
  max-width: 1200px;
  margin: 20px auto 0 auto;
  font-size: 13px;
  color: #999999;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.copy-txt {
  margin: 5px 10px;
  color: #dddddd;
}

.copy-txt a {
  color: #dddddd;
}

a {
  text-decoration: none;
  color: #999999;
  transition: color 0.2s;
}
a:hover {
  color: #ffffff;
}

.router-link-active {
  color: #ffffff;
}

/* ==================== 📱 移动端响应式样式 ==================== */
@media screen and (max-width: 991px) {
  .nav {
    padding-top: 30px;
  }

  /* 核心：变并排为上下堆叠 */
  .nav-c {
    width: 90%;
    flex-direction: column;
    margin-bottom: 20px;
  }

  /* 1. 导航区处理：变成 2x2 的网格分布 */
  .nav-c1 {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .c1-h {
    width: 50%; /* 一行排两组导航 */
    margin-bottom: 25px;
  }

  .c1-h .head {
    margin-bottom: 12px;
    position: relative;
    padding-bottom: 4px;
  }
  /* 手机端加一条淡淡的下划线更好看 */
  .c1-h .head::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 20px;
    height: 2px;
    background-color: #3a4d7c;
  }

  /* 2. 信息区处理：消除硬编码的左间距，撑满 */
  .nav-c2 {
    width: 100%;
    padding-left: 0;
    margin-top: 10px;
    border-top: 1px dashed #2c395b;
    padding-top: 25px;
  }

  .c2-div {
    margin-top: 15px;
    flex-direction: column; /* 热线和邮箱在手机端上下错开，防止挤在一起 */
  }

  .contact-item {
    margin-bottom: 8px;
  }

  .item-email {
    margin-left: 0; /* 手机端清除左边距 */
  }

  /* 3. 二维码区处理 */
  .nav-c3 {
    width: 100%;
    align-items: flex-start; /* 配合整体居左对齐 */
    margin-top: 20px;
    flex-direction: row; /* 手机端二维码和文字可以左右排，省地方 */
    background: #1e2a4a;
    padding: 12px;
    border-radius: 6px;
  }

  .c3-txt1 {
    margin-top: 0;
    margin-left: 15px;
    text-align: left;
    display: flex;
    align-items: center;
    color: #b2c0e0;
  }

  /* 4. 版权备案区处理 */
  .line {
    width: 90%;
  }

  .nav-d {
    width: 90%;
    flex-direction: column; /* 手机端版权信息一行一个，避免右侧溢出 */
    align-items: center;
    text-align: center;
  }

  .copy-txt {
    margin: 4px 0;
  }
}
</style>
